<template>
  <el-dialog title='填写发票寄送方式' :visible.sync='invoiceVisible' width='600px' @close='invoiceClose'
             center :close-on-click-modal='false'>
    <el-form :model='invoiceData' label-width='140px' :rules='rules' ref='ruleForm' size='medium'
             class='p20'>
      <div-border label='基本信息' divStyle='margin-top: 10px'>
        <el-form-item label='发票寄送方式：' prop='sendType' style='margin-top: 15px;'>
          <el-radio v-model='invoiceData.sendType' :label='0'>快递</el-radio>
          <el-radio v-model='invoiceData.sendType' :label='1'>其它</el-radio>
        </el-form-item>
        <el-form-item v-if='invoiceData.sendType === 0' label='快递类型：' prop='expressType'>
          <el-input
            :style="'width:100%'"
            v-model='invoiceData.expressType'
            placeholder='请输入快递类型'
            autocomplete='off'
            size='mini'
          />
        </el-form-item>
        <el-form-item v-if='invoiceData.sendType === 0' label='快递单号：' prop='courierNumber'>
          <el-input
            :style="'width:100%'"
            v-model='invoiceData.courierNumber'
            placeholder='请输入快递单号'
            autocomplete='off'
            size='mini'
          />
        </el-form-item>
        <el-form-item label='寄送日期：' prop='sendTime' style='margin-bottom: 20px;'>
          <el-date-picker
            v-model='invoiceData.sendTime'
            type='datetime'
            value-format='yyyy-MM-dd HH:mm:ss'
            size='mini'
            placeholder='选择寄送日期' />
        </el-form-item>
        <el-form-item label='备注：' prop='remake'>
          <el-input
            :style="'width:100%'"
            type='textarea'
            v-model='invoiceData.remake'
            placeholder='请输入备注'
            autocomplete='off'
            size='mini'
          />
        </el-form-item>
      </div-border>
      <div class='btnContainer'>
        <el-button class='searchBtn' size='mini' :loading='buttonLoading' @click='invoiceClick'>确定
        </el-button>
        <el-button class='resetBtn' size='mini' @click='invoiceClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import DivBorder from '@/components/divBorder';
  import { sendInvoice } from '@/service/getData';

  export default {
    name: 'sendInvoice',
    components: { DivBorder },
    data() {
      return {
        invoiceVisible: false,
        buttonLoading: false,
        invoiceData: {
          basicId: '',
          sendType: 0,
          expressType: '',
          courierNumber: '',
          sendTime: '',
          remake: '',
          reconciliator: ''
        },
        rules: {
          courierNumber: [
            {
              required: true,
              message: '请输入快递单号',
              trigger: 'blur',
            },
          ],
          sendTime: [
            {
              required: true,
              message: '请选择寄送日期',
              trigger: 'change',
            },
          ],
          expressType: [
            {
              required: true,
              message: '请输入快递类型',
              trigger: 'blur',
            },
          ],
          sendType: [
            {
              required: true,
              message: '请选择发票寄送方式',
              trigger: 'change',
            },
          ],
        },
      };
    },
    methods: {
      // 寄送发票
      invoiceClick() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.buttonLoading = true;
            const {
              status,
              message,
            } = await sendInvoice({
              ...this.invoiceData,
              reconciliator: this.invoiceData.reconciliator
            });
            this.buttonLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.invoiceVisible = false;
            this.$emit('success')
          }
        });
      },
      invoiceOpen(id,reconciliator) {
        this.invoiceData.basicId = id;
        this.invoiceData.reconciliator = reconciliator
        this.invoiceVisible = true;
      },
      invoiceClose() {
        this.invoiceVisible = false;
        this.$refs.ruleForm.resetFields();
      },
    },
  };
</script>

<style lang='scss' scoped>
  .btnContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 13px;
    margin-top: 20px;

    button {
      margin: 0 15px;
    }
  }

  ::v-deep {
    .el-date-editor {
      width: 100%;
    }
  }
</style>
